import { CognitoUserPool } from 'amazon-cognito-identity-js';

type PoolDataType = {
  UserPoolId: string;
  ClientId: string;
};

const poolData: PoolDataType = {
  UserPoolId: process.env.REACT_APP_AWS_USER_POOL_ID!,
  ClientId: process.env.REACT_APP_AWS_CLIENT_ID!,
};

const UserPool =
  poolData.ClientId && poolData.UserPoolId ? new CognitoUserPool(poolData) : undefined;

export { UserPool };
